export default __webpack_public_path__ + "static/media/slider5.179ebd74.jpg";